import { useEffect, useState } from "react";
import "./CustomFormComponent.scss";
import Select from "react-select";
import { color } from "framer-motion";
import { unitIndex } from "../../../store/atoms";
import { useSetRecoilState } from "recoil";
import { getToken } from "../../auth/authConfig";
import axios from "axios";

const CustomFormComponent = ({
  formData,
  setFormData,
  formFields,
  disabled,
  option,
  fetchAutopopulateData,
  unitIndexes,
  setUnitIndexValue
}) => {
  const [certificationOptions, setCertificationOptions] = useState([]);

  console.log("getting formData", formData)

  // Fetch certifications from API
  const fetchCertifications = async () => {
    try {
      const token = await getToken();
      const url = `${process.env.REACT_APP_SERVER_URL}/api/certifications`;
      
      const response = await axios.get(url, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });

      if (response.status === 200) {
        const data = response.data;
        if (data.certifications) {
          // Transform certifications to the format expected by react-select
          const formattedOptions = data.certifications.map(cert => ({
            value: cert,
            label: cert
          }));
          setCertificationOptions(formattedOptions);
        }
      }
    } catch (error) {
      console.error("Error fetching certifications:", error);
    }
  };

  const handleChange = (name, newValue) => {
    if (name === "unitIndex") {
      const fetchAutopopulateData = async () => {
        const token = await getToken();
        const apiUrl = `${process.env.REACT_APP_SERVER_URL}/api/auto-populate/unitdetails`;
        try {
          const { data } = await axios.post(
            apiUrl,
            { unitIndex: newValue },
            { headers: { "oidc-token": token, Accept: "application/json" } }
          );
          if (data) {
            const userName = localStorage.getItem("userName");
            const userEmail = localStorage.getItem("myemail");
            const newData = data;
            newData.unitDetails.forEach((item) => {
              if (item.name === "qualityManager") {
                item.value = userName;
              }
              if (item.name === "qualityManagerEmail") {
                item.value = userEmail;
              }
            });

            setFormData(data?.unitDetails || []);
          }
        } catch (e) {
          console.log("error while getting the form data", e);
        }
      };
      fetchAutopopulateData();
    }
    setFormData(
      (prevState) =>
        prevState &&
        prevState.map((item) =>
          item.name === name ? { ...item, value: newValue } : item
        )
    );
  };

  // const handleMultiSelectChange = (name, selectedOption) => {
  //   setFormData((prevData) => ({
  //     prevData &&
  //     prevState.map((item) =>
  //       item.name === name ? { ...item, value: JSON.stringify(
  //         selectedOption.map((option) => option.value)
  //       ) } : item
  //     )

  //     // audit_criteria: JSON.stringify(
  //     //   selectedOption.map((option) => option.value)
  //     // ),
  //   }));
  // };
  const handleMultiSelectChange = (name, selectedOptions) => {
    setFormData((prevState) =>
      prevState?.map((item) =>
        item.name === name
          ? {
              ...item,
              value: JSON.stringify(
                selectedOptions.map((option) => option.value)
              ),
            }
          : item
      )
    );
  };

  // Parse the audit_criteria string to an array
  const multiOptions = formData.find((item) => item.name === "certifications");

  //   function normalizeValue(value) {
  //     if (typeof value === "string" && value.trim() !== "") { // Ensure it's a non-empty string
  //         if (!(value.startsWith("[") && value.endsWith("]"))) {
  //             value = `["${value.replace(/"/g, '\\"')}"]`; // Wrap it inside an array, escape quotes
  //         }
  //         return JSON.parse(value); // Convert string to an array
  //     }
  //     return []; // Return an empty array if value is empty
  // }

  function normalizeValue(value) {
    if (typeof value === "string" && value.trim() !== "") {
      try {
        // If the value is already a valid JSON array, parse it
        if (value.startsWith("[") && value.endsWith("]")) {
          return JSON.parse(value);
        }
      } catch (error) {
        console.error("JSON Parse Error:", error);
      }

      // If it's a plain string, split by commas and trim spaces
      return value.split(/,\s*/).map((item) => item.trim());
    }
    return [];
  }

  const findingOptions = formFields.find(
    (item) => item.name === "certifications"
  );
  const selectedMultiValues = multiOptions?.value
    ? normalizeValue(multiOptions.value)
    : [];

  const selectedOptions = findingOptions.options.filter((option) =>
    // selectedMultiValues.includes(option.value)
    (selectedMultiValues || []).includes(option.value)
  );
  // const selectedOptions = findingOptions.options.filter((option) =>
  //   Array.isArray(selectedMultiValues) &&
  //   selectedMultiValues.map(String).includes(String(option.value)) // Ensure both are strings
  // );

  // const findingOptions = formFields.find((item) => item.name === "certifications");
  // const selectedMultiValues = multiOptions?.value ? JSON.parse(multiOptions.value) : [];
  // const selectedOptions = findingOptions.options.filter((option) => selectedMultiValues.includes(option.value));

  const handleRadioChange = (name, value) => {
    handleChange(name, value);
  };

  const handleInputChange = (name, value) => {
    handleChange(name, value);
  };

  const isFormValid = () => {
    return formFields.every((field) => {
      if (field.required) {
        // Check if the field is marked as 'required'
        const fieldData = formData.find((item) => item.name === field.name); // Find the corresponding form data based on field name
        return fieldData && fieldData.value !== "" && fieldData.value !== "[]"; // Check if the value is not empty
      }
      return true; // For non-required fields, return true as they can be empty
    });
  };

  useEffect(() => {
    // run this effect if any changes in formData
    disabled(!isFormValid());
  }, [formData]);

  useEffect(() => {
    setUnitIndexValue(formData.find((item) => item.name === "unitIndex")?.value);
  }, [formData]);

  useEffect(() => {
    // Fetch certifications when component mounts
    fetchCertifications();
  }, []);

  return (
    <div id="form-component">
      <form>
        <div className="form-component-container">
          {formFields.map((field, index) => (
            <div className="input-box" key={index}>
              {field.name === "certifications" ? (
                <label className="input-label">
                  {field.label}<span className="required-span">*</span>
                  <span
                    style={{
                      fontWeight: "normal",
                    }}
                  >
                    -
                  </span>
                  <i
                    style={{
                      color: "gray",
                    }}
                  >
                    You can select more than one option
                  </i>
                  
                </label>
              ) : (
                <label className="input-label">
                  {field.label} <span className="required-span">*</span>
                </label>
              )}
              {/* <label className="input-label">
                {field.label} <span className="required-span">*</span>
              </label> */}
              {field.type === "select" ? (
                <Select
                  // options={field.options}
                  options={
                    field.name === "unitIndex" && unitIndexes 
                      ? unitIndexes 
                      : field.name === "certifications" && certificationOptions.length > 0
                      ? certificationOptions
                      : field.options
                  }
                  value={
                    field.name === "certifications"
                      ? selectedOptions
                      : formData.find((item) => item.name === field.name)?.value
                      ? {
                          value: formData.find(
                            (item) => item.name === field.name
                          ).value,
                          label: field.name === "unitIndex" && unitIndexes 
                            ? unitIndexes.find(
                                (option) =>
                                  option.value ===
                                  formData.find((item) => item.name === field.name)
                                    .value
                              )?.label
                            : field.options.find(
                                (option) =>
                                  option.value ===
                                  formData.find((item) => item.name === field.name)
                                    .value
                              )?.label,
                        }
                      : null // Set to null when no value is selected
                  }
                  onChange={(selectedOption) => {
                    if (field.name === "unitIndex") {
                      setUnitIndexValue(selectedOption.value);
                    }
                    field.name === "certifications"
                      ? handleMultiSelectChange(field.name, selectedOption)
                      : handleChange(field.name, selectedOption.value);
                  }}
                  isSearchable={true}
                  className="searchable-select"
                  classNamePrefix="searchable-select"
                  isDisabled={field?.disable}
                  isMulti={field.name === "certifications" ? true : false}
                />
              ) : field.type === "radio" ? (
                <div className="radio-container">
                  {field.options.map((option, idx) => (
                    <label
                      className="radio-field"
                      key={idx}
                      style={{ marginRight: "10px" }}
                    >
                      <input
                        type="radio"
                        className="radio-circle"
                        name={field.name}
                        value={option}
                        required={field.required}
                        checked={
                          formData.find((item) => item.name === field.name)
                            ?.value === option
                        }
                        onChange={() => handleRadioChange(field.name, option)}
                      />
                      <span className="radio-option-text">{option}</span>
                    </label>
                  ))}
                </div>
              ) : (
                <input
                  className="input-field"
                  type={field.type}
                  id={field.name}
                  name={field.name}
                  placeholder={field.placeholder || ""}
                  required={field.required}
                  value={
                    formData.find((item) => item.name === field.name)?.value ||
                    ""
                  }
                  disabled={field?.disable || false}
                  onChange={
                    (e) => handleInputChange(field.name, e.target.value) // Handling input field change
                  }
                />
              )}
            </div>
          ))}
        </div>
      </form>
    </div>
  );
};

export default CustomFormComponent;
